export class MenuConfig {
	public defaults: any = {
		header: {
			self: {},
			items: [
				{
					title: 'Tableau de bord',
					root: true,
					alignment: 'left',
					page: 'tableaudebord',
					icon: 'fa fa-home',
				},
				{
					title: 'Gestion',
					root: true,
					alignment: 'left',
					toggle: 'click',
					icon:'fa fa-tasks',
					submenu: [
						{
							title: 'Abonnements',
							bullet: 'dot',
							icon: 'fa fa-clipboard-check',
							page: 'abonnements',

						},
						{
							title: 'Comptes',
							bullet: 'dot',
							icon: 'fa fa-user-tag',
							page: 'clients',

						},
						{
							title: 'Distributeurs',
							bullet: 'dot',
							icon: 'fa fa-user-tie',
							page: 'distributeurs',

						},
						{
							title: 'Factures',
							bullet: 'dot',
							icon: 'fa fa-file-invoice',
							page: 'factures',
						},
						{
							title: 'Réglements',
							bullet: 'dot',
							icon: 'fa fa-wallet',
							page: 'reglements',
						},
						// {
						// 	title: 'Publicités',
						// 	bullet: 'dot',
						// 	icon: 'fa fa-bullhorn',
						// 	page: 'publicites',
						// },
						{
							title: 'Marque blanche',
							bullet: 'dot',
							icon: 'fa fa-globe-europe',
							page: 'marques',
						},
					]
				},
				{
					title: 'Paramètrages',
					root: true,
					alignment: 'left',
					toggle: 'click',
					icon: 'fa fa-cogs',
					submenu: [
						{
							title: 'Tarifs Modules&Options',
							bullet: 'dot',
							icon: 'fa fa-boxes',
							page: 'modules',

						},
						{
							title: 'Packs commerciales',
							bullet: 'dot',
							icon: 'fa fa-box-open',
							page: 'packages',

						},
						{
							title: 'Paramètres généraux',
							bullet: 'dot',
							icon: 'fa fa-cog',
							page: 'parametres',

						},
						{
							title: 'Types distributeurs',
							bullet: 'dot',
							icon: 'fa fa-cog',
							page: 'distributeurtypes',

						},
					]
				},
				{
					title: 'Support',
					root: true,
					alignment: 'left',
					page: 'tickets',
					icon: 'fa fa-headset',
				},
				{
					title: 'Guide',
					root: true,
					alignment: 'left',
					toggle: 'click',
					icon: 'fa fa-life-ring',
					submenu: [
						{
							title: 'Liste des guides',
							bullet: 'dot',
							icon: 'fa fa-list-ul',
							page: 'guides/liste',

						},
						{
							title: 'Liste des catégories',
							bullet: 'dot',
							icon: 'fa fa-layer-group',
							page: 'guides/categories',

						},
						{
							title: 'Historique mise à jour',
							bullet: 'dot',
							icon: 'fa fa-history',
							page: 'guides/historique',

						}
					]
				},
			]
		},
		aside: {
			self: {},
			items: []
		},
	};

	public get configs(): any {
		return this.defaults;
	}
}
